<svg
  xmlns="http://www.w3.org/2000/svg"
  height="24"
  viewBox="0 96 960 960"
  width="24"
  fill="currentColor"
>
  <path
    d="M402 816v-60h59l121-139-121-141h-74l-71 366q-8 45-34 69.5T215 936q-41 0-68.5-24T119 852q0-27 15-43.5t39-16.5q21 0 34.5 12t13.5 32q0 11-4.5 20.5T204 872q4 2 8.5 3t9.5 1q13 0 22-12.5t13-32.5l69-355H200v-60h137l21-106q9-45 36-69.5t67-24.5q41 0 67.5 24t26.5 60q0 27-15 43.5T501 360q-20 0-34-11.5T453 318q0-10 4-19.5t10-15.5q-2-2-6-3.5t-8-1.5q-13 0-22.5 12T417 321l-18 95h189v60h-47l83 96 78-96h-48v-60h186v60h-58L662 617l120 139h58v60H654v-60h48l-80-93-82 93h48v60H402Z"
  />
</svg>
